/***
*
*   LOGO
*   Replace the image in /images with your own logo
*
**********/

import { Link, ClassHelper } from 'components/lib';
// import LogoWhite from './images/logo-white.svg';
// import LogoMarkWhite from './images/logo-mark-white.svg';
// import LogoColor from './images/logo-color.svg';
// import LogoMarkColor from './images/logo-mark-color.svg';
import BrandTitle from "./images/BrandTitle.svg";
import BrandLogo from "./images/brandLogo.svg";
import BrandWhiteLogo from "./images/whiteLogo.svg";
import BrandWhiteLogoTitle from "./images/whiteLogoTitle.svg";
import Style from './logo.tailwind.js';

export function Logo(props) {

  const Logo = {
    color: {
      logo: BrandTitle,
      mark: BrandLogo
    },
    white: {
      logo: BrandWhiteLogoTitle,
      mark: BrandWhiteLogo
    }
  }

  const logoStyle = ClassHelper(Style, props);

  return (
    <Link url='/dashboard' className={logoStyle}>
      <img src={Logo[props.color ? 'color' : 'white'][props.mark ? 'mark' : 'logo']} alt='Logo' />
    </Link>
  )
}
